import { RiArrowDownSLine, RiArrowRightSLine } from "react-icons/ri";
import TableNotes from "./TableNotes";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

export default function Notes({ setData }) {
  const [show, setShow] = useState(false);
  const [allNotes, setAllNotes] = useState([
    {
      id: 1,
      description:
        "Candidates salary will start from the date of Joining work. Until then they will only get food allowance. Driver will get salary after they obtain driving license and start work.",
    },
    {
      id: 2,
      description:
        "If any candidate found unfit/ unwilling to work/ want to go back/ Home Sick/ Terminated by company or Visa sponsor All Actual Government charges will be billed to Soundlines Recruitment Team directly. apart from any other additional expenses which was done by company on the candidate. The return Air ticket will be borne by candidates or SLR team.   ",
    },
  ]);

  // const handleTemplateChange = (event) => {
  //   const template = templates.find((template) => template?.name === event.target.value);
  //   setSelectedTemplate(template);
  // };
  // useEffect(()=>{
  //   if(templates) setSelectedTemplate(templates[0]);
  // },[templates])

  // const handleNoteUpdate = (updatedTemplate) => {
  //   setSelectedTemplate(updatedTemplate);
  // };

  // const deleteNote = (updatedTemplate) => {
  //   setSelectedTemplate(updatedTemplate)
  // };

  useEffect(() => {
   
      const copyNotes = [...allNotes];
      let newNotes = [];
      copyNotes.forEach((item) => {
        newNotes.push({ description: item?.description });
      });
      setData((prev) => ({
        ...prev,
        notes: newNotes,
      }));
  },allNotes)

  const addNote = () => {
    const newNote = {
      id: Math.floor(Math.random() * 100000),
      description: "",
    };
    setAllNotes((prevState) => [...prevState, newNote]);
  };

  //Final Data
  // const notes = selectedTemplate?.template_note?.map(note => ({
  //   description: note.description
  // }));

  // setData(notes,'notes')

  return (
    <div className="flex flex-wrap  gap-4 ">
      <div className="max-w-sm min-w-max  w-full flex gap-3 items-center h-fit">
        <button
          className="p-1 rounded-md ring-1 ring-slate-200"
          onClick={() => setShow((p) => !p)}
          type="button"
        >
          {show ? (
            <RiArrowDownSLine size={"1.4rem"} />
          ) : (
            <RiArrowRightSLine size={"1.4rem"} />
          )}
        </button>
        <div>
          <h2 className="font-semibold">Notes</h2>
          <p>Provide notes.</p>
        </div>
      </div>
      <div
        className={`w-full m-2 overflow-hidden px-4 rounded-md transition-all  ${
          show ? "h-auto py-4 ring-1 ring-slate-200 " : "h-0 overflow-hidden"
        }`}
      >
        <div className="flex justify-between p-3">
          <button
            type="button"
            className="bg-red text-white p-2 rounded-md mt-2 ml-2"
            onClick={addNote}
          >
            + Add Another
          </button>

          {/* commented select template */}
          {/* <div className="flex gap-3 items-center">
                <p>Template : </p>
                <select
                    value={selectedTemplate?.name}
                    onChange={handleTemplateChange}
                    className="select select-sm select-bordered"
                  >
                    <option value="" hidden>Select Template</option>
                    {templates?.map((template) => (
                      <option key={template.name} value={template.name}>
                        {template.name}
                      </option>
                    ))}
                  </select>
          </div> */}
        </div>
        <TableNotes allNotes={allNotes} setAllNotes={setAllNotes} />
      </div>
    </div>
  );
}
